/** The server owns the state machine; this only maps its status to the screen the candidate needs next. */
export function routeFor(status: string): string {
  switch (status) {
    case 'INVITED': return '/profile'
    case 'REGISTERED':
    case 'CONSENT_PENDING': return '/my-consent'
    case 'READY':
    case 'ASSESSMENT_1_SUBMITTED':
    case 'ASSESSMENT_1_IN_PROGRESS':
    case 'ASSESSMENT_2_IN_PROGRESS': return '/instructions'
    default: return '/finished'
  }
}
